import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Announcement, AnnouncementFilter, AnnouncementResult } from '../models/announcement.model';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private _backendBaseUrl: string = environment.backEndUrl;

  constructor(private _http: HttpClient) { }

  getAnnouncements(filter: AnnouncementFilter): Observable<AnnouncementResult> {
    return this._http.post<AnnouncementResult>(this._backendBaseUrl + '/announcements', filter);
  }

  createAnnouncement(announcement: Announcement): Observable<Announcement> {
    return this._http.post<Announcement>(this._backendBaseUrl + '/announcements/add', announcement);
  }

  updateAnnouncement(announcement: Announcement): Observable<Announcement> {
    return this._http.put<Announcement>(this._backendBaseUrl + `/announcements/${announcement.id}`, announcement);
  }

  deleteAnnouncement(id: string): Observable<void> {
    return this._http.delete<void>(this._backendBaseUrl + `/announcements/${id}`);
  }

  getUnseenAnnouncements(): Observable<Announcement[]> {
    return this._http.get<Announcement[]>(this._backendBaseUrl + '/announcements/unseen');
  }

  acknowledgeAnnouncements(): Observable<void> {
    return this._http.post<void>(this._backendBaseUrl + '/announcements/acknowledge', {});
  }
}
